module.exports = __webpack_public_path__ + "img/server-1-1.bf3413b1.png";